import {Component, computed, inject, input} from '@angular/core';
import {FiltersSidebarFilterComponent} from '../filters-sidebar-filter/filters-sidebar-filter.component';
import {IItem} from '../../../../../types/IItem';
import { FiltersSidebarFilterCheckboxesComponent } from '../filters-sidebar-filter-checkboxes/filters-sidebar-filter-checkboxes.component';
import {LinkComponent} from '../../../../../shared/components/link/link.component';
import {IconsComponent} from '../../../../../shared/components/icons/icons.component';
import {ResultsStore} from '../../../../../shared/store/results.store';

@Component({
  selector: 'app-filters-sidebar-size-filter',
  imports: [
    FiltersSidebarFilterComponent,
    FiltersSidebarFilterCheckboxesComponent,
    LinkComponent,
    IconsComponent
  ],
  templateUrl: './filters-sidebar-size-filter.html',
  styleUrl: './filters-sidebar-size-filter.css',
})
export class FiltersSidebarSizeFilter {
  label = input.required<string>();
  key = input.required<string>();

  private resultsStore = inject(ResultsStore);

  readonly size = computed(() => this.resultsStore.search_params()?.rawsize ?? '');

  readonly showSizeFilter = computed(() => this.size() || this.countSizes() > 1);

  readonly countSizes = computed(() => {
    return [...new Set(this.resultsStore.results().map((item: IItem) => item.size).filter((option: string) => option !== ''))].length;
  });
}
